export const isRobotNoFollow = (value: string): boolean => value?.toLowerCase() === "nofollow";
export const isRobotNoIndex = (value: string): boolean => value?.toLowerCase() === "noindex";
